// REACT_APP_USERNAME and REACT_APP_PASSWORD have been removed.
// Credentials must never be embedded in the frontend bundle.
// Any RouteXL integration must go through a backend proxy endpoint.
//
// MANUAL STEP (Google Maps key): restrict REACT_APP_GOOGLE_MAPS_API_KEY by HTTP
// referrer in Google Cloud Console → APIs & Services → Credentials so it can
// only be used from https://yourpos.example.com/*.
export default {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    ENDPOINT_AUTH: process.env.REACT_APP_AUTH_URL,
    REACT_APP_ROOT_URL: process.env.REACT_APP_ROOT_URL,
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    // Viva cloud-terminal payments. ON by default; set
    // REACT_APP_VIVA_TERMINAL_ENABLED=false to hide the option.
    VIVA_TERMINAL_ENABLED: process.env.REACT_APP_VIVA_TERMINAL_ENABLED !== "false",
    // "Send app invitation" (QR claim link). OFF by default: the button is
    // shown greyed out, since customers with a real email already get the
    // activation link in their order emails. Set
    // REACT_APP_APP_INVITE_ENABLED=true (and redeploy) to turn it on.
    APP_INVITE_ENABLED: process.env.REACT_APP_APP_INVITE_ENABLED === "true",
  }